import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgUserPlus from '../../svg/user-plus.svg'
import { IconProps } from '../icon-props'

const UserPlusIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgUserPlus
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-userplus', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default UserPlusIcon
